import React from 'react';
import { css } from 'emotion';
import styled, { keyframes } from 'react-emotion';
import SliderModal from './SliderModal';
import { connect } from 'react-redux';
import {
    addStop,
    pushStopAtIndex,
    editStop,
    updateDestLocation,
    updatePickupLocation,
    updateCityOfStop,
    addFirstStop,
    fetchLocationByLatLong,
    updateDestCity,
    updateTripType,
    removeLastStop,
    updatePickupCity
} from '../../actions/rideActions';
import Geocode from "react-geocode";
import Moment from 'moment';
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';

/* global tw */

Geocode.setApiKey("AIzaSyDrm-YN3aa0Lj3VMz-hD0_IExL2BYZ06qA");

const fadeUp = keyframes`
    from { opacity: 0; transform: translateY(6px); }
    to   { opacity: 1; transform: translateY(0); }
`;

const SearchInput = styled.input`
    width: 100%;
    padding: 1rem 1.25rem;
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-weight: 700;
    font-size: 1.25rem;
    color: #F5F5F7;
    background: #111118;
    border: 1px solid rgba(170, 11, 202, 0.25);
    border-radius: 6px;
    outline: none;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    letter-spacing: -0.02em;
    appearance: none;
    -webkit-appearance: none;
    &::placeholder {
        color: #5A5A6E;
        font-weight: 500;
    }
    &:focus {
        border-color: rgba(170, 11, 202, 0.6);
        box-shadow: 0 0 0 3px rgba(170, 11, 202, 0.12);
    }
    @media (min-width: 992px) {
        font-size: 1.5rem;
    }
`;

const SuggestionItem = styled.div`
    padding: 0.875rem 1rem;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    transition: background 0.15s ease;
    animation: ${fadeUp} 0.2s ease both;
    animation-delay: ${props => props.index * 0.04}s;
    background: ${props => props.active ? 'rgba(170, 11, 202, 0.12)' : 'transparent'};
    border: 1px solid ${props => props.active ? 'rgba(170, 11, 202, 0.25)' : 'transparent'};
    &:hover {
        background: rgba(170, 11, 202, 0.1);
        border-color: rgba(170, 11, 202, 0.2);
    }
    span {
        font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
        font-weight: ${props => props.active ? '600' : '500'};
        font-size: 0.9375rem;
        color: ${props => props.active ? '#F5F5F7' : '#9898A8'};
        letter-spacing: -0.01em;
        line-height: 1.4;
    }
    @media (min-width: 992px) {
        span { font-size: 1.0625rem; }
    }
`;

const CityItem = styled.p`
    padding: 0.875rem 1rem;
    border-radius: 6px;
    cursor: pointer;
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-weight: 500;
    font-size: 0.9375rem;
    color: #9898A8;
    letter-spacing: -0.01em;
    margin: 0.25rem 0;
    transition: all 0.15s ease;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    animation: ${fadeUp} 0.2s ease both;
    animation-delay: ${props => props.index * 0.04}s;
    &:hover {
        background: rgba(170, 11, 202, 0.1);
        color: #F5F5F7;
        border-radius: 6px;
    }
    &::before {
        content: '';
        width: 6px;
        height: 6px;
        border-radius: 9999px;
        background: rgba(170, 11, 202, 0.5);
        flex-shrink: 0;
    }
`;

const LocationDot = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0, opacity: 0.5 }}>
        <circle cx="8" cy="8" r="3" fill="#AA0BCA" />
        <circle cx="8" cy="8" r="6" stroke="#AA0BCA" strokeWidth="1.5" strokeDasharray="2 2" />
    </svg>
);

class PlacesModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            text: "",
            isOverlayActive: false,
            isSliderModalActive: false,
            formEditing: false,
            isPlace: false,
            pickupAddress: null,
            destinationAddress: null,
            pickupLocation: "",
            destLocation: '',
            pickupCity: '',
            destCity: '',
            pickupPlaces: [],
            destPlaces: [],
            address: '',
            isFocus: false,
        };
        this.textInput = React.createRef();
        this.myInput = React.createRef();
        this.updateDestLocation = this.updateDestLocation.bind(this);
        this.updatePickupLocation = this.updatePickupLocation.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.attachInputRef = this.attachInputRef.bind(this);
        this.placesInput = null;
    }

    handleChange = address => {
        this.setState({ address });
    };

    handleSelect = address => {
        this.props.onClick();
        geocodeByAddress(address)
            .then(results => {
                if (results[0].address_components.length > 1) {
                    let longName = "";
                    results[0].address_components.map((ac) => {
                        if (ac.types.includes("administrative_area_level_1")) {
                            longName = ac.long_name;
                        }
                    });
                    // Some places (Union Territories, etc.) have no administrative_area_level_1
                    if (!longName) {
                        if (this.props.isPickup) {
                            this.updatePickupLocation(results[0]);
                        } else {
                            this.updateDestLocation(results[0]);
                        }
                        this.setState({ address: "" });
                        return;
                    }
                    geocodeByAddress(longName)
                        .then(results1 => {
                            if (this.props.isPickup && results1[0]) {
                                this.updatePickupLocation(results[0], results1[0]);
                                this.setState({ address: "" });
                            } else if (this.props.isPickup) {
                                this.updatePickupLocation(results[0]);
                                this.setState({ address: "" });
                            } else {
                                this.updateDestLocation(results[0]);
                                this.setState({ address: "" });
                            }
                            getLatLng(results[0]);
                        })
                        .catch(error => {
                            // Fallback if second geocode fails
                            if (this.props.isPickup) {
                                this.updatePickupLocation(results[0]);
                            } else {
                                this.updateDestLocation(results[0]);
                            }
                            this.setState({ address: "" });
                        });
                } else {
                    if (this.props.isPickup) {
                        this.updatePickupLocation(results[0]);
                    } else {
                        this.updateDestLocation(results[0]);
                    }
                    this.setState({ address: "" });
                }
            })
            .catch(error => console.error('Error', error));
        this.setState({ formEditing: false });
    };

    componentWillMount() {
        if (typeof analytics === `undefined`) return;
    }

    updatePickupLocation = (details, altLoc) => {
        let city = '';
        let flag = 0;
        const cleanAddress = details.formatted_address.replace(/^[A-Z0-9]{4,8}\+[A-Z0-9]{2,},\s*/i, '');
        // eslint-disable-next-line
        analytics.track('Pickup Changed:', { category: 'clicks', label: cleanAddress });
        this.setState({ pickupAddress: cleanAddress });
        this.props.dispatch(updatePickupLocation({
            name: cleanAddress,
            locLat: details.geometry.location.lat(),
            locLng: details.geometry.location.lng()
        }));
        let types = ['locality', 'administrative_area_level_2', 'administrative_area_level_1'];
        if (details.address_components.length > 1) {
            for (let i = 0; i < 3; i++) {
                for (let j = 0; j < details.address_components.length; j++) {
                    if (details.address_components[j].types[0] === types[i]) {
                        city = details.address_components[j].long_name;
                        flag = 1;
                        break;
                    }
                }
                if (flag === 1) break;
            }
        } else {
            city = details.address_components[0].long_name;
            flag = 1;
        }
        if (city === "Bangalore" || city === "Bengaluru Rural" || city === "Bengaluru Urban" || city === "Bangalore Rural" || city === "Bangalore Urban") city = "Bengaluru";
        if (city === "Secunderabad") city = "Hyderabad";
        this.setState({ pickupCity: city });
        // eslint-disable-next-line
        analytics.track('Pickup Changed:', { category: 'clicks', label: city });
        this.props.dispatch(updatePickupCity({ city: city, cityLat: '', cityLng: '' }));
        if (altLoc) {
            this.props.dispatch(fetchLocationByLatLong(city, altLoc.address_components[0].long_name));
        } else {
            this.props.dispatch(fetchLocationByLatLong(city, ""));
        }
        this.props.dispatch(addFirstStop({
            city: city,
            name: details.formatted_address,
            latitude: details.geometry.location.lat(),
            longitude: details.geometry.location.lng()
        }));
        if (this.state.isRoundtrip) {
            this.props.dispatch(editStop(2, {
                city: city,
                name: details.formatted_address,
                latitude: details.geometry.location.lat(),
                longitude: details.geometry.location.lng(),
                cityLat: '',
                cityLng: ''
            }));
        }
    }

    updateDestLocation = (details) => {
        let destCity = '';
        let flag = 0;
        const cleanAddress = details.formatted_address.replace(/^[A-Z0-9]{4,8}\+[A-Z0-9]{2,},\s*/i, '');
        if (this.state.pickupAddress === null) {
            this.props.dispatch(pushStopAtIndex(1, {
                seqId: 2,
                name: cleanAddress,
                latitude: details.geometry.location.lat(),
                longitude: details.geometry.location.lng()
            }));
        } else if (this.state.destinationAddress === null) {
            this.props.dispatch(addStop({
                name: cleanAddress,
                latitude: details.geometry.location.lat(),
                longitude: details.geometry.location.lng()
            }));
            if (this.props.isRoundtrip) {
                this.props.dispatch(addStop(this.props.ride.stops[0]));
            }
        } else {
            this.props.dispatch(editStop(1, {
                name: cleanAddress,
                latitude: details.geometry.location.lat(),
                longitude: details.geometry.location.lng()
            }));
        }
        // eslint-disable-next-line
        analytics.track('Destination Changed:', { category: 'clicks', label: cleanAddress });
        this.setState({ destinationAddress: cleanAddress });
        this.props.dispatch(updateDestLocation({
            name: cleanAddress,
            locLat: details.geometry.location.lat(),
            locLng: details.geometry.location.lng()
        }));
        let types = ['locality', 'administrative_area_level_2', 'administrative_area_level_1'];
        for (let i = 0; i < 3; i++) {
            for (let j = 0; j < details.address_components.length; j++) {
                if (details.address_components[j].types[0] === types[i]) {
                    destCity = details.address_components[j].long_name;
                    flag = 1;
                    break;
                }
            }
            if (flag === 1) break;
        }
        if (destCity === "Bangalore" || destCity === "Bengaluru Rural" || destCity === "Bengaluru Urban" || destCity === "Bangalore Rural" || destCity === "Bangalore Urban") destCity = "Bengaluru";
        if (destCity === "Secunderabad") destCity = "Hyderabad";
        this.setState({ destinationCity: destCity });
        // eslint-disable-next-line
        analytics.track('Destination Changed:', { category: 'clicks', label: destCity });
        this.props.dispatch(updateDestCity({ city: destCity, cityLat: '', cityLng: '' }));
        this.getLatLngOfCity(destCity, 'dest');
    }

    getLatLngOfCity = (city, type) => {
        let self = this;
        Geocode.fromAddress(city).then(json => {
            let location = json.results[0].geometry.location;
            if (type === 'pickup') {
                self.props.dispatch(updateCityOfStop({ city, cityLat: location.lat, cityLng: location.lng }, 0));
            } else {
                self.props.dispatch(updateCityOfStop({ city, cityLat: location.lat, cityLng: location.lng }, 1));
                self.props.dispatch(updateDestCity({ city, cityLat: location.lat, cityLng: location.lng }));
            }
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.active !== prevProps.active) {
            this.setState({ address: "" });
        }
        if (this.props.ride.rentalType !== 2) {
            if (prevState.isFocus !== this.state.isFocus) {
                window.setTimeout(() => {
                    const el = document.getElementById('inputRef');
                    if (el) el.focus();
                }, 0);
            }
        }
    }

    componentDidMount() {
        let ride = this.props.ride;
        if (ride.pickup.loc !== "") this.setState({ pickupAddress: this.props.ride.pickup.loc });
        if (ride.dest.loc !== "") this.setState({ destinationAddress: this.props.ride.dest.loc });
        this.setState({ isFocus: this.props.isFocus });
    }

    attachInputRef(input) {
        this.placesInput = input;
    }

    handleStaticCities = (data) => {
        this.props.onClick();
        if (this.props.isPickup) {
            this.props.dispatch(updatePickupCity({ city: data.label, cityLat: data.value.latitude, cityLng: data.value.longitude, cityLeadTime: this.props.ride.leadTime.leadTime }));
        } else if (!this.props.isPickup) {
            this.props.dispatch(updateDestCity({ city: data.label, cityLat: data.value.latitude, cityLng: data.value.longitude }));
        }
    }

    render() {
        const options = { componentRestrictions: { country: 'in' } };
        const { rentalType } = this.props.ride;
        const isPickup = this.props.isPickup;

        let selfFiltered = this.props.ride.selfDriveCities.filter(c => c.name.toLowerCase().includes(this.state.text.toLowerCase()));

        return (
            <SliderModal
                placesModal
                onStart={() => this.setState({ isFocus: !this.state.isFocus })}
                active={this.props.active}
                onDone={this.props.onClick}>
                <div className={css`
                    ${tw`w-full flex flex-wrap px-5 py-5`};
                    background: #1A1A24;
                `}>
                    {/* Header */}
                    <div className={css`${tw`w-full mb-4`}`}>
                        <p className={css`
                            font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
                            font-weight: 500;
                            font-size: 0.75rem;
                            text-transform: uppercase;
                            letter-spacing: 0.1em;
                            color: #CB53D1;
                            margin-bottom: 0.375rem;
                        `}>
                            {isPickup ? 'Pickup' : 'Dropoff'}
                        </p>
                        <h3 className={css`
                            font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
                            font-weight: 800;
                            font-size: 1.5rem;
                            color: #F5F5F7;
                            letter-spacing: -0.03em;
                            margin: 0;
                        `}>
                            Where {isPickup ? 'are you starting' : 'are you headed'}?
                        </h3>
                    </div>

                    {/* Google Places — Outstation, Airport & Hourly */}
                    {rentalType !== 2 && (
                        <PlacesAutocomplete
                            value={this.state.address}
                            onChange={this.handleChange}
                            onSelect={this.handleSelect}
                            searchOptions={options}
                            shouldFetchSuggestions={this.state.address.length > 1}
                            inputProps={{ ref: input => { this.searchInput = input; } }}>
                            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                <div className={css`${tw`w-full`}`}>
                                    <div className={css`
                                        position: relative;
                                        display: flex;
                                        align-items: center;
                                    `}>
                                        <svg className={css`
                                            position: absolute;
                                            left: 1rem;
                                            opacity: 0.4;
                                            flex-shrink: 0;
                                        `} width="18" height="18" viewBox="0 0 18 18" fill="none">
                                            <circle cx="8" cy="8" r="5.5" stroke="#F5F5F7" strokeWidth="1.5"/>
                                            <path d="M12.5 12.5L16 16" stroke="#F5F5F7" strokeWidth="1.5" strokeLinecap="round"/>
                                        </svg>
                                        <SearchInput
                                            id="inputRef"
                                            {...getInputProps({
                                                autoFocus: true,
                                                placeholder: 'Search location...',
                                            })}
                                            style={{ paddingLeft: '2.75rem' }}
                                        />
                                    </div>
                                    <div className={css`
                                        width: 100%;
                                        max-height: 14rem;
                                        overflow-y: scroll;
                                        -webkit-overflow-scrolling: touch;
                                        margin-top: 0.5rem;
                                        padding: 0.25rem 0;
                                    `}>
                                        {loading && (
                                            <div className={css`
                                                padding: 1rem;
                                                font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
                                                font-size: 0.875rem;
                                                color: #5A5A6E;
                                                display: flex;
                                                align-items: center;
                                                gap: 0.5rem;
                                            `}>
                                                <span style={{ width: 16, height: 16, borderRadius: '50%', border: '2px solid rgba(170,11,202,0.3)', borderTopColor: '#AA0BCA', display: 'inline-block', animation: 'spin 0.7s linear infinite' }} />
                                                Searching...
                                            </div>
                                        )}
                                        {suggestions.map((suggestion, index) => (
                                            <SuggestionItem
                                                key={suggestion.placeId}
                                                index={index}
                                                active={suggestion.active}
                                                {...getSuggestionItemProps(suggestion, {})}
                                            >
                                                <LocationDot />
                                                <span>{suggestion.description}</span>
                                            </SuggestionItem>
                                        ))}
                                    </div>
                                    <div className={css`
                                        display: flex;
                                        align-items: center;
                                        gap: 0.375rem;
                                        margin-top: 0.5rem;
                                        opacity: 0.4;
                                    `}>
                                        <p className={css`
                                            font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
                                            font-size: 0.6875rem;
                                            color: #9898A8;
                                        `}>Powered by</p>
                                        <img
                                            className={css`height: 14px;`}
                                            src={require('../../assets/img/google-logo.svg')}
                                            alt="Google"
                                        />
                                    </div>
                                </div>
                            )}
                        </PlacesAutocomplete>
                    )}

                    {/* Self Drive city search */}
                    {rentalType === 2 && (
                        <div className={css`${tw`w-full`}`}>
                            <div className={css`position: relative; display: flex; align-items: center;`}>
                                <svg className={css`position: absolute; left: 1rem; opacity: 0.4;`} width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <circle cx="8" cy="8" r="5.5" stroke="#F5F5F7" strokeWidth="1.5"/>
                                    <path d="M12.5 12.5L16 16" stroke="#F5F5F7" strokeWidth="1.5" strokeLinecap="round"/>
                                </svg>
                                <SearchInput
                                    id="inputRef"
                                    autoFocus
                                    placeholder="Search cities..."
                                    value={this.state.text}
                                    onChange={(e) => this.setState({ text: e.target.value })}
                                    style={{ paddingLeft: '2.75rem' }}
                                />
                            </div>
                            <div className={css`max-height: 20rem; overflow-y: scroll; -webkit-overflow-scrolling: touch; margin-top: 0.5rem;`}>
                                {this.state.text !== '' && selfFiltered.map((city, i) => (
                                    <CityItem key={i} index={i} onClick={() => this.handleStaticCities(city)}>
                                        {city.name}
                                    </CityItem>
                                ))}
                                {this.state.text !== '' && selfFiltered.length === 0 && (
                                    <p className={css`
                                        padding: 1rem;
                                        font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
                                        font-size: 0.9375rem;
                                        color: #5A5A6E;
                                    `}>No cities found for "{this.state.text}"</p>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Airport pickup cities */}
                    {rentalType === 3 && isPickup && (
                        <div className={css`max-height: 20rem; overflow-y: scroll; -webkit-overflow-scrolling: touch; width: 100%;`}>
                            {this.props.ride.airportPickupCities.map((city, i) => (
                                <CityItem key={i} index={i} onClick={() => this.handleStaticCities(city)}>
                                    {city.name}
                                </CityItem>
                            ))}
                        </div>
                    )}

                    {/* Airport dropoff cities */}
                    {rentalType === 3 && !isPickup && (
                        <div className={css`max-height: 20rem; overflow-y: scroll; -webkit-overflow-scrolling: touch; width: 100%;`}>
                            {this.props.ride.airportDropCities.map((city, i) => (
                                <CityItem key={i} index={i} onClick={() => this.handleStaticCities(city)}>
                                    {city.name}
                                </CityItem>
                            ))}
                        </div>
                    )}

                </div>
            </SliderModal>
        );
    }
}

const mapStateToProps = (state) => ({
    ride: state.ride,
    stops: state.ride.stops,
    isUserLoggedIn: state.user.isLoggedIn,
});

export default connect(mapStateToProps)(PlacesModal);
